/**
 * Shared formatting helpers for the profile track.
 * Ported verbatim from the iOS profile components (source of truth).
 */

/** TikTok-style 3-stat row formatter (client-native ProfileStats.tsx). */
export function formatStatRowListening(totalSeconds: number): {
  value: string;
  label: string;
} {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  if (hours > 0) {
    if (minutes === 0) return { value: `${hours}h`, label: "Listened" };
    return { value: `${hours}h ${minutes}m`, label: "Listened" };
  } else if (minutes > 0) {
    if (seconds === 0) return { value: `${minutes}`, label: "min" };
    return { value: `${minutes}m ${seconds}s`, label: "Listened" };
  }
  return { value: `${seconds}`, label: "sec" };
}

/** Number formatter with K-suffix (client-native ProfileStats.tsx). */
export function formatStatNumber(num: number): string {
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num.toString();
}

/** Card-face listening formatter (client-native ListeningTimeCard.tsx). */
export function formatCardListening(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  if (hours > 0) {
    if (minutes === 0) return `${hours}h`;
    return `${hours}h ${minutes}m`;
  } else if (minutes > 0) {
    if (seconds === 0) return `${minutes} min`;
    return `${minutes}m ${seconds}s`;
  }
  return `${seconds} sec`;
}

/** Popup value formatter (client-native ProfileScreen.tsx getStatValue). */
export function formatPopupListening(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);
  if (hours > 0) {
    return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
  } else if (minutes > 0) {
    return seconds === 0 ? `${minutes} min` : `${minutes}m ${seconds}s`;
  }
  return `${seconds} sec`;
}
